export default __webpack_public_path__ + "static/media/img_baseBunnyCrochetRattle_rose_p.2818859f.jpg";